var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table"},_vm._l((_vm.table.rows),function(row,idx){return _c('div',{key:idx,staticClass:"tr"},_vm._l((row),function(col,idx){return _c('div',{key:idx,staticClass:"td"},[_c('div',{staticClass:"td__title"},[_vm._v(_vm._s(col.name)+":")]),_vm._v(" "),_c('div',{staticClass:"td__value"},[_vm._v(_vm._s(col.value))])])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }